/* ==========================================================================
   [LOADER] — fade out once page is ready
   ========================================================================== */
window.addEventListener('load', () => {
  const loader = document.getElementById('loader');
  if (loader) {
    setTimeout(() => loader.classList.add('done'), 400);
  }
});

/* ==========================================================================
   [NAV] — sticky nav appears after scrolling past hero
   ========================================================================== */
const nav = document.getElementById('nav');
if (nav) {
  addEventListener('scroll', () => {
    nav.classList.toggle('show', scrollY > innerHeight * 0.5);
  }, { passive: true });
}

/* ==========================================================================
   [FINISH CHIPS] — just toggles active state (no 3D to update)
   ========================================================================== */
document.querySelectorAll('.chip').forEach(chip => chip.addEventListener('click', () => {
  document.querySelector('.chip.active')?.classList.remove('active');
  chip.classList.add('active');
}));

/* ==========================================================================
   [FILTERS] — collections category filtering
   ========================================================================== */
document.querySelectorAll('.filter').forEach(btn => btn.addEventListener('click', () => {
  document.querySelector('.filter.active')?.classList.remove('active');
  btn.classList.add('active');
  const f = btn.dataset.filter;
  document.querySelectorAll('#grid .card').forEach(card => {
    card.classList.toggle('hide', f !== 'all' && !card.dataset.cat.split(' ').includes(f));
  });
}));

/* ==========================================================================
   [FORM] — enquiry → pre-filled WhatsApp message (no backend required)
   ========================================================================== */
const enquiryForm = document.getElementById('enquiry');
if (enquiryForm) {
  enquiryForm.addEventListener('submit', e => {
    e.preventDefault();
    const d = new FormData(e.target);
    const whatsappNumber = enquiryForm.dataset.whatsapp || '';
    const msg = `Hello Enamels & Metal,%0A%0AName: ${encodeURIComponent(d.get('name') || '—')}`
              + `%0AInterested in: ${encodeURIComponent(d.get('piece') || '—')}`
              + `%0A%0A${encodeURIComponent(d.get('msg') || '')}`;
    window.open(`https://wa.me/${whatsappNumber}?text=${msg}`, '_blank', 'noopener');
  });
}

/* ==========================================================================
   [REVEAL] — fade/rise elements as they enter the viewport
   ========================================================================== */
const io = new IntersectionObserver(entries => entries.forEach(en => {
  if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
}), { threshold: 0.16 });
document.querySelectorAll('.reveal:not(.in)').forEach(el => io.observe(el));